module.exports = __webpack_public_path__ + "static/img/IMG_20241123_112504.7a45f137.jpg";